import { QualificationListDTO } from '../qualification/qualification-list.dto';
import { TenantConnectionDTO } from '../tenant/tenant-connection.dto';
import { TeamListDTO } from '../team/team-list.dto';

export class UserDialogDTO {

    id: string;

    firstName: string;

    lastName: string;

    image: string;

    email: string;

    phone: string;

    cellPhone: string;

    tenants: Array<TenantConnectionDTO>;

    teams: Array<TeamListDTO>;
    
    qualifications: Array<QualificationListDTO>;

}
